module.exports = __webpack_public_path__ + "static/media/location3.ef09f9d3.webp";